export default __webpack_public_path__ + "static/media/inl-link.787def7d.png";